import { Point } from '../../../common/maths/geometry/pointTypes';

/**
 * For zoom triggered by external events (such as zoom slider), since there is no event trigger point, we would want
 * it to zoom to the last zoomed in area. This function uses the user's scroll position to calculate that point on
 * the canvas viewport
 */
export const calculateExternalScaleEventPosition = (canvasViewportNode: HTMLElement, zoomScale: number): Point => {
    if (!canvasViewportNode) return { x: 0, y: 0 };

    const canvasViewportClientRect = canvasViewportNode.getBoundingClientRect();

    // If board is zoomed out or not zoomed, use the canvas viewport mid point in order to zoom to the middle of
    // the canvas viewport
    if (zoomScale <= 1) {
        return {
            x: canvasViewportClientRect.width / 2,
            y: canvasViewportClientRect.height / 2,
        };
    }

    const { scrollTop, scrollLeft, scrollHeight, scrollWidth } = canvasViewportNode;

    // If board is zoomed in, zoom in to the last zoomed in area
    return {
        x: (scrollLeft / (scrollWidth - canvasViewportClientRect.width)) * canvasViewportClientRect.width,
        y: (scrollTop / (scrollHeight - canvasViewportClientRect.height)) * canvasViewportClientRect.height,
    };
};
